let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fgvs9")).then(() => parcelRequire('6kP7g'));